export enum FoundPatientStatus {
    extraInformationNeeded = 'extraInformationNeeded',
    foundPatientInOrganization = 'foundPatientInOrganization',
    foundPatientOutsideOfOrganization = 'foundPatientOutsideOfOrganization',
    noPatientFound = 'noPatientFound',
    noSearch = 'noSearch',
}
